import { StrictMode, useEffect, useRef } from 'react'
import React from 'react';
import {Canvas} from '@react-three/fiber'
import { Perf } from 'r3f-perf';
import { OrbitControls } from '@react-three/drei';
import Experience from './Experience.js'
import { Leva } from 'leva';
import Measurements from './clickTools/Measurements.js';
import Info from './clickTools/Info.js';
import CameraControl from './clickTools/CameraControl.js';
import ColorChange from './clickTools/ColorChange.js';

export default function App()
{   

    useEffect(()=>{
        console.log('rendered')
    })

    const ref = useRef()

    return (
        <>
            <Leva className="relative flex-1 z-40 w-1/5 max-w-[50px]" theme={{
              colors: {
                elevation1: '#1c1c1c', // background color of the main panel
                elevation2: '#292929', // background color of the folders
                elevation3: '#346379', // background color of the inputs
                highlight1: '#d4af37', // highlight color (e.g., for active items)
                highlight2: '#d4af37', // secondary highlight color,
                highlight3: ' #fff',
                vivid1: '#d4af37', // vivid color
                accent1: '#ffffff', // color for text and labels
                accent2: '#fff', // secondary text color
                accent3:'#fff'
              },
              sizes: {
                rowHeight:'15px',
                checkboxSize:'10px',
                rootWidth: 'fit', // width of the Leva panel
                controlWidth:'fit',
                controlHeight: 'fit', // height of the controls
              },
              fonts: {

                root: '8px Arial, sans-serif', // font size and type
                label: '8px Arial, sans-serif', // font size and type for labels
              },
              radii: {                
                sm: '0px', // small radius for rounded corners
                md: '0px', // medium radius for rounded corners
              }

              }}/>        
            <StrictMode>
                <Canvas flat shadows gl={{ antialias: true }} camera={{ position: [0, 1225, 2500], near: 0.5, far: 100000, fov: 35 }}>
                    <Perf  position="top-left" />
                    <OrbitControls makeDefault ref={ref}/>                    
                    <Experience/>    
                    <CameraControl controls={ref} />                   
                </Canvas>
            </StrictMode>
            <Measurements />
            <Info/>
            <ColorChange/>

        </>
    )
}